import { createContext, useContext } from 'react'

import { ExtendedSlateProps } from '../types.js'

export const SlateEditorContext = createContext<
  Record<string, ExtendedSlateProps>
>({})

export const useSlateEditor = (id: string): ExtendedSlateProps => {
  const context = useContext(SlateEditorContext)
  return context[id]
}
